function switchState(el) {

  let video = document.querySelector(`#${el}`);


  if (video.paused == true) {
    video.play();
    video.controls = true;
    video.classList.add('hide-controls')
    // video.style.display = "none";
  } else {
    video.pause();
    video.controls = false;
    video.classList.remove('hide-controls')

    // video.style.display = "flex";
  }
}






document.addEventListener('click', function (event) {

  if (event.target.matches('video-play')) {
      // Run your code to open a modal
      event.target.classList.toggle('hide')
      switchState()
  }

}, false);



// Set video padding 

let videoIframe = document.querySelectorAll('.video-aspect iframe')

for (let index = 0; index < videoIframe.length; index++) {
  let element = videoIframe[index];

  console.log(element.clientWidth  / element.clientHeight)

  let height = element.clientHeight
  let width = element.clientWidth
  let aspect = width / height
  let aspectPadding = aspect * 100

  element.parentNode.style.paddingTop = aspectPadding + '%'
  
}